import {css, cx} from "@panda/css";

import {UserIcon} from "@pg-design/icons-module";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {AVATAR_FADE_MS, useProfileAvatarReveal} from "../hooks/use_profile_avatar_reveal";

interface IProps {
    className?: string;
    fill: string;
    size: string;
    src?: string | null;
    wrapperColor: string;
    wrapperSize: string;
}

export const UserProfileAvatar = (props: IProps) => {
    const {className, fill, size, src, wrapperColor, wrapperSize} = props;
    const {showIcon, showImage} = useProfileAvatarReveal(src);
    const sizePx = Number.parseFloat(wrapperSize) * 10;

    return (
        <span
            className={cx(avatarSlotStyle, className)}
            data-image-ready={showImage}
            data-testid={KM_COMMON_TEST_IDS.PROFILE_AVATAR}
            style={{height: `${wrapperSize}rem`, width: `${wrapperSize}rem`}}
        >
            {showImage && (
                <img
                    alt=""
                    className={cx(avatarImageStyle, fadeLayerStyle, fadeInStyle)}
                    height={sizePx}
                    referrerPolicy="no-referrer"
                    src={src ?? undefined}
                    width={sizePx}
                />
            )}

            {showIcon && (
                <span className={cx(iconLayerStyle, fadeLayerStyle, showImage ? fadeOutStyle : fadeInStyle)}>
                    <UserIcon fill={fill} size={size} wrapperColor={wrapperColor} wrapperSize={wrapperSize} wrapperType="circle" />
                </span>
            )}
        </span>
    );
};

const avatarSlotStyle = css({
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
    overflow: "hidden",
    position: "relative",
    borderRadius: "50%"
});

const fadeLayerStyle = css({
    transition: `opacity ${AVATAR_FADE_MS}ms var(--transition-timingFunction)`,
    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const fadeInStyle = css({
    opacity: 1
});

const fadeOutStyle = css({
    opacity: 0,
    pointerEvents: "none"
});

const avatarImageStyle = css({
    borderRadius: "50%",
    display: "block",
    flexShrink: 0,
    height: "100%",
    inset: 0,
    objectFit: "cover",
    position: "absolute",
    width: "100%"
});

const iconLayerStyle = css({
    display: "inline-flex",
    inset: 0,
    position: "absolute"
});
import {css, cx} from "@panda/css";

import {UserIcon} from "@pg-design/icons-module";
import {KM_COMMON_TEST_IDS} from "@pg-mono/test-ids";

import {AVATAR_FADE_MS, useProfileAvatarReveal} from "../hooks/use_profile_avatar_reveal";

interface IProps {
    className?: string;
    fill: string;
    size: string;
    src?: string | null;
    wrapperColor: string;
    wrapperSize: string;
}

export const UserProfileAvatar = (props: IProps) => {
    const {className, fill, size, src, wrapperColor, wrapperSize} = props;
    const {showIcon, showImage} = useProfileAvatarReveal(src);
    const sizePx = Number.parseFloat(wrapperSize) * 10;

    return (
        <span
            className={cx(avatarSlotStyle, className)}
            data-image-ready={showImage}
            data-testid={KM_COMMON_TEST_IDS.PROFILE_AVATAR}
            style={{height: `${wrapperSize}rem`, width: `${wrapperSize}rem`}}
        >
            {showImage && (
                <img
                    alt=""
                    className={cx(avatarImageStyle, fadeLayerStyle, fadeInStyle)}
                    height={sizePx}
                    referrerPolicy="no-referrer"
                    src={src ?? undefined}
                    width={sizePx}
                />
            )}

            {showIcon && (
                <span className={cx(iconLayerStyle, fadeLayerStyle, showImage ? fadeOutStyle : fadeInStyle)}>
                    <UserIcon fill={fill} size={size} wrapperColor={wrapperColor} wrapperSize={wrapperSize} wrapperType="circle" />
                </span>
            )}
        </span>
    );
};

const avatarSlotStyle = css({
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
    overflow: "hidden",
    position: "relative",
    borderRadius: "50%"
});

const fadeLayerStyle = css({
    transition: `opacity ${AVATAR_FADE_MS}ms var(--transition-timingFunction)`,
    "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
    }
});

const fadeInStyle = css({
    opacity: 1
});

const fadeOutStyle = css({
    opacity: 0,
    pointerEvents: "none"
});

const avatarImageStyle = css({
    borderRadius: "50%",
    display: "block",
    flexShrink: 0,
    height: "100%",
    inset: 0,
    objectFit: "cover",
    position: "absolute",
    width: "100%"
});

const iconLayerStyle = css({
    display: "inline-flex",
    inset: 0,
    position: "absolute"
});
